module.exports = "https://web-assets.ifttt.com/packs/media/icons-v2/generic-0127442d.svg";